<template>
    <div class="col-md-12">
        <div class="container-fluid bg-light py-3">
            <div class="h2">Create recurring job</div>
            <div class="flash-message">
                <FlashMessage :position="'top'"></FlashMessage>
            </div>
        </div>
        <form @submit.prevent="addRecurring">
            <div class="container-fluid bg-light py-3">
                <div class="col-md-6">
                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-6">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="recurring.name==='' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Name of recurring job"
                                           autocomplete="none"
                                           v-model="recurring.name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="recurring.driver.id==='' && isSubmit? 'border-danger':''">
                                    <v-select
                                        :options="drivers"
                                        v-model="recurring.driver"
                                        label="name"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-6">
                                <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="recurring.client.id==='' && isSubmit? 'border-danger':''">
                                    <v-select
                                        :options="clients"
                                        v-model="recurring.client"
                                        label="name"
                                        @input="getClientAddresses();getClientAgreements()"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="recurring.agreement.id==='' && isSubmit? 'border-danger':''">
                                    <v-select
                                        :options="agreements"
                                        v-model="recurring.agreement"
                                        @input="getAgreementsProductsServices()"
                                        label="name"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Stops</div>
                            <div v-if="recurring.stops.length>0">
                                <div class="pt-3">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                            <tr>
                                                <th class="border-right text-left">
                                                    Stop #
                                                </th>
                                                <th class="border-right text-center">
                                                    Address
                                                </th>
                                                <th class="border-right text-center">
                                                    Type
                                                </th>
                                                <th>

                                                </th>
                                            </tr>
                                            </thead>
                                            <draggable class="drag" v-model="recurring.stops" tag="tbody">
                                                <tr v-for="(stop,k) in recurring.stops" :key="stop.addressName">
                                                    <td scope="row">
                                                        {{ k + 1 }}
                                                    </td>
                                                    <td class="text-center" style="width: 90%">
                                                        {{ stop.addressName }}, {{ stop.addressStreet }},
                                                        {{ stop.addressZip }} {{ stop.addressCity }},
                                                    </td>
                                                    <td class="text-center" style="width: 8%">
                                                        {{ stop.type == "1" ? 'Pick-up' : 'Drop-off' }}
                                                    </td>
                                                    <td class="text-center" style="width: 1%">
                                                        <div class="btn float-center btn-default btn-sm"
                                                             @click="deleteStop(k)">
                                                            <div
                                                                class="material-icons-outlined cursor-pointer text-primary"
                                                                title="delete product">delete
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </draggable>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Booking info</div>
                            <div>
                                <div class="form-group mb-0">
                                    <div class="form-group mb-0 row">
                                        <div class="col-md-2">
                                            <label for="product-name"
                                                   class="d-block mb-0 font-weight-bold">Products</label>
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="recurring.product==='' && isSubmit? 'border-danger':''">
                                                <select required id="product-name"
                                                        class="form-control border-0 py-0 shadow-none"
                                                        v-model="recurring.agreement_product_id">
                                                    <option v-for="item in products" v-bind:value="item.id">
                                                        {{ item.product.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <label class="d-block mb-0 font-weight-bold">Services</label>
                                            <div v-for="item in services">
                                                <label class="newInput">{{ item.service.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="recurring.agreement_services_ids">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="d-block mb-0 font-weight-bold">Days</label>
                                            <div v-for="(item, k) in daysList">
                                                <label class="newInput">{{ item.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="recurring.recurring_dates">
                                                    <span class="checkmark"></span>
                                                </label>
                                                <input
                                                    type="time"
                                                    v-model="daysList[k].intervals_from">
                                                -
                                                <input
                                                    type="time"
                                                    v-model="daysList[k].intervals_to">
                                                <br/> <br/>
                                            </div>

                                        </div>

                                        <div class="col-md-3">
                                            <label class="d-block mb-0 font-weight-bold">Price</label>
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="recurring.total_price==='' && isSubmit? 'border-danger':''">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="none"
                                                       v-model="recurring.total_price">
                                            </div>
                                            <br/>
                                            <label class="d-block mb-0 font-weight-bold">Cost price</label>
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="recurring.cost_price==='' && isSubmit? 'border-danger':''">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="none"
                                                       v-model="recurring.cost_price">
                                            </div>

                                            <div class="form-group">
                                                <div class="custom-control- custom-checkbox- mb-3">
                                                    <label class="custom-control-label-" for="instantly_delivered">
                                                        <b>Mark booking as instantly delivered:</b>
                                                    </label>
                                                    <input type="checkbox" class="custom-control-input-"
                                                           id="instantly_delivered"
                                                           v-model="recurring.is_instantly_delivered">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br/>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">

                    </div>

                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">General info</div>
                            <div>
                                <div class="form-group mb-0">
                                    <div class="form-group mb-0 row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                 <textarea
                                                     class="form-control"
                                                     v-model="recurring.note"
                                                     placeholder="Note">
                                                  </textarea>
                                            </div>
                                            <br/>

                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Reference"
                                                       autocomplete="none"
                                                       v-model="recurring.reference">
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br/>
                <br/>

                <br/>
                <br/>

                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-4 bg-white rounded-lg h-100">
                            <div class="h3 mb-3">Products</div>
                            <div class="">
                                <div class="pt-3">
                                    <div class="table-responsive">
                                        <table class="table border">
                                            <tbody>
                                            <tr>
                                                <th>Reference</th>
                                                <th>Name</th>
                                                <th>Colli</th>
                                                <th>Height(cm)</th>
                                                <th>Width(cm)</th>
                                                <th>Length(cm)</th>
                                                <th>Volume(m3)</th>
                                                <th>Weight(kg)</th>
                                            </tr>

                                            <tr v-for="colli in recurring.colli">
                                                <td>{{ colli.reference }}</td>
                                                <td>{{ colli.name }}</td>
                                                <td>{{ colli.colli }}</td>
                                                <td>{{ colli.height }}</td>
                                                <td>{{ colli.width }}</td>
                                                <td>{{ colli.measure }}</td>
                                                <td>{{ colli.volume }}</td>
                                                <td>{{ colli.weight }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               placeholder="123456 (order #)"
                                                               v-model="colli.reference">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               placeholder="Blue chair"
                                                               v-model="colli.name">
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-model="colli.colli">
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="form-group">
                                                        <input type="number"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-on:input="onChangeColliSize($event)"
                                                               v-model="colli.height">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="number"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-on:input="onChangeColliSize($event)"
                                                               v-model="colli.width">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="number"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-on:input="onChangeColliSize($event)"
                                                               v-model="colli.measure">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-model="colli.volume">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="none"
                                                               class="form-control"
                                                               v-model="colli.weight">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <div class="btn btn-success sm" @click="addColli()">
                                                            <div
                                                                class="material-icons-outlined cursor-pointer mr-1">
                                                                add_circle
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="alert alert-danger" role="alert"
                                                         v-if="referenceExistsMessage!==''">
                                                        <br/> <i> {{ referenceExistsMessage }} </i>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr v-for="colli in clientColliList">
                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.reference }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.name }}
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.totalColliAmount }}
                                                    </div>
                                                </td>

                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    {{ colli.volume }}
                                                </td>
                                                <td>
                                                    {{ colli.weight }}
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <div class="btn btn-success sm"
                                                             @click="addExistingColli(colli.id)">
                                                            <div
                                                                class="material-icons-outlined cursor-pointer mr-1">
                                                                add_circle
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row save-recurring">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-success btn-lg mt-5" @click="validation()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <form @submit.prevent="toggleModal()">
            <div class="col-md-6 p-4 mb-0 bg-white rounded-lg add-stop">
                <div class="h3 mb-3">Add stop</div>
                <div class="">
                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-6">
                                <v-select
                                    class="address-select"
                                    :options="clientAddresses"
                                    v-model="newStop.address"
                                    v-on:input="onChangeAddress($event)"
                                    label="value"
                                >
                                </v-select>
                            </div>
                            <div class="col-md-6">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <vue-google-autocomplete
                                        autocomplete="none"
                                        onfocus="this.setAttribute('autocomplete', 'none');"
                                        id="map2"
                                        types="establishment"
                                        classname="form-control border-0 py-0 shadow-none form-input"
                                        placeholder="Start typing address"
                                        v-on:placechanged="getAddressDataAutocomplete"
                                    >
                                    </vue-google-autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressName==='' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Full Name"
                                           autocomplete="none"
                                           v-model="newStop.addressName">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressStreet==='' && isSubmit? 'border-danger':''">
                                    <input autocomplete="none" required type="text"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Address"
                                           v-model="newStop.addressStreet">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group z">
                        <div class="form-group row">
                            <div class="col-md-4">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressZip==='' && isSubmit? 'border-danger':''">
                                    <input autocomplete="none" required type="text"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Zip"
                                           v-model="newStop.addressZip"
                                           @input="getCityByZip($event)"
                                    >
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressCity==='' && isSubmit? 'border-danger':''">
                                    <input autocomplete="none" required type="text"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="City"
                                           v-model="newStop.addressCity">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressCountryId==='' && isSubmit? 'border-danger':''">
                                    <select class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="newStop.addressCountryId">
                                        <option value="1" :selected=true>Denmark</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-8">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.note==='' && isSubmit? '':''">
                                    <input type="text"
                                           autocomplete="none"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Note"
                                           v-model="newStop.note">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.addressPhone==='' && isSubmit? '':''">
                                    <input type="text"
                                           autocomplete="none"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Phone"
                                           v-model="newStop.addressPhone">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-group row">
                            <div class="col-md-8">
                                <div
                                    class="d-flex align-items-center rounded-lg div-focus">
                                    <button class="btn mb-3 btn-success">
                                        <i class="oi oi-plus" title="add stop"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-4">

                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                    :class="newStop.type==='' && isSubmit? 'border-danger':''">
                                    <select
                                        required
                                        class="form-control border-0 py-0 shadow-none pr-5"
                                        v-model="newStop.type">
                                        <option value="1">Pick-up</option>
                                        <option value="2">Drop-off</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Is this stop permanent?
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addPermanentStop">
                            <div class="form-group">
                                <div class="col-md-6">
                                    <select class="form-control"
                                            v-model="permanentStop.isPermanent">
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="permanentStop.isPermanent==0">
                                <div class="form-group">
                                    <div class="">
                                        <div class="col-md-6">
                                            From
                                            <date-picker
                                                aria-required="true"
                                                manual-input
                                                v-model="permanentStop.startDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>

                                        <div class="col-md-6">
                                            To
                                            <date-picker
                                                aria-required="true"
                                                manual-input
                                                v-model="permanentStop.endDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6">
                                        Price
                                        <input type="text"
                                               required
                                               autocomplete="none"
                                               class="form-control"
                                               v-model="permanentStop.price">
                                    </div>
                                </div>
                            </div>

                            <div>
                                <button class="btn btn-success">
                                    Save
                                </button>
                                <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                    Cancel
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import draggable from 'vuedraggable';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";

export default {
    name: "RecurringCreate",
    mixins: [datePickerOptionsMixin],
    components: {VueGoogleAutocomplete, DatePicker, VueTimepicker, draggable},
    props: {
        driverTypeExternal: {type: Number, required: true},
    },
    data() {
        return {
            isSubmit: false,
            recurring: {
                driver: {id: '', name: ''},
                client: {id: '', name: ''},
                agreement: {id: '', name: ''},
                agreement_services_ids: [],
                recurring_dates: [],
                total_price: 0,
                note: '',
                reference: '',
                stops: [],
                colli: [],
                is_instantly_delivered: 0,
            },
            drivers: [
                {id: '', name: ''},
            ],
            clients: [
                {id: '', name: ''},
            ],
            agreements: [
                {id: '', name: ''},
            ],
            products: {},
            services: {},
            daysList: [],
            clientAddresses: [
                {id: '', value: ''},
            ],
            newStop: [],
            show: false,
            activeModalInterval: false,
            permanentStop: {isPermanent: 0},
            colli: {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'isExisting': 0
            },
            referenceExistsMessage: '',
            clientColliList: {},
        }
    },
    methods: {
        fetchData() {
            this.fillDayList()
            axios.get('/client-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clients.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch()
            axios.get(`/driver-list?type=${this.driverTypeExternal}`)
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.drivers.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch();
        },
        fillDayList() {
            this.daysList.push({
                id: 1,
                name: 'Monday',
                intervals_from: null,
                intervals_to: null,
            })
            this.daysList.push({
                id: 2,
                name: 'Tuesday',
                intervals_from: null,
                intervals_to: null,
            })
            this.daysList.push({
                id: 3,
                name: 'Wednesday',
                intervals_from: null,
                intervals_to: null
            })
            this.daysList.push({
                id: 4,
                name: 'Thursday',
                intervals_from: null,
                intervals_to: null
            })
            this.daysList.push({
                id: 5,
                name: 'Friday',
                intervals_from: null,
                intervals_to: null
            })
            this.daysList.push({
                id: 6,
                name: 'Saturday',
                intervals_from: null,
                intervals_to: null
            })
            this.daysList.push({
                id: 7,
                name: 'Sunday',
                intervals_from: null,
                intervals_to: null
            })
        },
        getClientAgreements() {
            axios.get(`/client-agreements/${this.recurring.client.id}`)
                .then(({data}) => {
                    this.recurring.agreement_product_id = '';
                    this.recurring.agreement_services_ids = [];
                    this.agreements = [{id: '', name: ''}]
                    this.recurring.agreement = {id: '', name: ''}
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.agreements.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                    if (data.length === 1) {
                        this.recurring.agreement.id = data[0].id;
                        this.recurring.agreement.name = data[0].name;
                        this.getAgreementsProductsServices()
                    }
                }).catch(error => this.agreements = [])
        },
        getAgreementsProductsServices() {
            this.recurring.agreement_product_id = '';
            this.recurring.agreement_services_ids = [];
            axios.get(`/product-list/${this.recurring.agreement.id}`)
                .then(({data}) => {
                    this.products = data.data;
                    this.recurring.agreement_product_id = data.data[0].id;
                }).catch(error => this.products = [])
            axios.get(`/service-list/${this.recurring.agreement.id}`)
                .then(({data}) => {
                    this.services = data.data;
                }).catch(error => this.services = [])
        },
        getAddressDataAutocomplete: function (addressData, placeResultData) {
            this.newStop = [];
            this.newStop.addressName = placeResultData.name;
            this.newStop.addressStreet = addressData.route + ' ' + addressData.street_number;
            this.newStop.addressZip = addressData.postal_code;
            this.newStop.addressCity = addressData.locality;
            this.newStop.addressCountryId = 1;
        },
        getClientAddresses() {
            axios.get(`/client-addresses/${this.recurring.client.id}`)
                .then(({data}) => {
                    this.clientAddresses = [];
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        const {length} = this.clientAddresses;
                        const id = length + 1;
                        const found = this.clientAddresses.some(el => el.value === `${value.name} ${value.street}, ${value.zip}  ${value.city}, Denmark`);
                        if (!found) this.clientAddresses.push({
                            id: parseInt(value.id),
                            value: `${value.name} ${value.street}, ${value.zip}  ${value.city}, Denmark`,
                            name: value.name,
                            street: value.street,
                            zip: value.zip,
                            city: value.city,
                            type: value.type,
                        });
                    });
                }).catch(error => this.clientAddresses = [])
        },
        getCityByZip: function (event) {
            axios.get(`/get-city-by-zip/${event.target.value}`)
                .then(({data}) => {
                    if (data !== '') {
                        this.newStop.addressCity = data;
                    }
                }).catch();
        },
        onChangeAddress(event) {
            let addressData = this.clientAddresses.filter(p => p.id == event.id);
            if (addressData.length > 0) {
                this.newStop = [];
                this.newStop.addressName = addressData[0].name;
                this.newStop.addressStreet = addressData[0].street;
                this.newStop.addressZip = addressData[0].zip;
                this.newStop.addressCity = addressData[0].city;
                this.newStop.addressCountryId = 1;
                this.newStop.type = addressData[0].type;
            }
        },
        addStop() {
            this.recurring.stops.push({
                addressName: this.newStop.addressName,
                addressStreet: this.newStop.addressStreet,
                addressZip: this.newStop.addressZip,
                addressCity: this.newStop.addressCity,
                addressCountryId: 1,
                type: this.newStop.type,
                permanentData: this.permanentStop,
            })
            this.permanentStop = {isPermanent: 0};
        },
        addPermanentStop() {
            this.addStop();
            this.toggleModal();
        },
        addRecurring() {
            if (this.recurring.driver.id !== '') {
                this.recurring.intervals = this.daysList;
                axios.post('/recurrings', this.recurring).then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Job succesfully created',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((error) => {
                    let errNotify = null;
                    if (error.response) {
                        errNotify = error.response.data;
                    } else if (error.request) {
                        errNotify = error.request;
                    } else {
                        errNotify = error.message;
                    }
                })
            }
        },
        validation() {
            this.isSubmit = true;
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        deleteStop(k) {
            this.recurring.stops = this.recurring.stops.filter((x, i) => i !== k);
        },
        getClientColliList() {
            axios.get(`/colli-list?clientIdSingle=${this.recurring.client.id}&groupReferences=true&excludeDelivered=true`)
                .then(({data}) => {
                    this.clientColliList = data.data;
                }).catch(error => this.clientColliList = [])
        },
        onChangeColliSize(event) {
            if (this.colli.height !== '' && this.colli.width !== '' && this.colli.measure !== '') {
                this.colli.volume = this.colli.height * this.colli.width * this.colli.measure / 1000000;
            }
        },
        addColli() {
            if (this.recurring.colli.filter(e => e.reference === this.colli.reference).length > 0) {
                this.referenceExistsMessage = 'reference already exists!';
            } else {
                if (this.colli.reference !== '' && this.colli.name !== '' && this.colli.colli !== '' && this.colli.volume !== '' && this.colli.weight !== '') {
                    this.recurring.colli.push({
                        reference: this.colli.reference,
                        name: this.colli.name,
                        colli: this.colli.colli,
                        height: this.colli.height,
                        width: this.colli.width,
                        measure: this.colli.measure,
                        volume: this.colli.volume,
                        weight: this.colli.weight,
                        isExisting: 0,
                    });
                    this.colliSaved = true;
                    this.recurring.totalVolume += parseFloat(this.colli.volume);
                    this.recurring.totalWeight += parseFloat(this.colli.weight);
                    //this.calculatePrice();
                }
                this.referenceExistsMessage = '';
            }
        },
        addExistingColli(id) {
            let existingColliData = this.clientColliList.filter(p => p.id == id)[0];
            this.recurring.colli.push({
                id: id,
                reference: existingColliData.reference,
                name: existingColliData.name,
                colli: existingColliData.totalColliAmount,
                height: existingColliData.height,
                width: existingColliData.width,
                //measure: existingColliData.measure,
                volume: existingColliData.volume,
                weight: existingColliData.weight,
                isExisting: 1,
            });
            this.colliSaved = true;
            this.recurring.totalVolume += parseFloat(existingColliData.volume);
            this.recurring.totalWeight += parseFloat(existingColliData.weight);
            //this.calculatePrice();
        },
    },
    created() {
        return this.fetchData()
    }
}
</script>
<style>
.flash-message {
    z-index: 10000;
    position: absolute;
    top: 105px;
    left: 30%;
    right: 0;
    background-color: #ffffff !important;
    border: none !important;
}

.flash-message p {
    height: 16px;
    /* Label (Small) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    letter-spacing: 0.02em;
    /* Dark Grey */
    color: #777777;
}

._vue-flash-msg-body__title {
    position: relative;
    width: 63px;
    height: 30px;
    left: 46px;
    top: 1px;
}

._vue-flash-msg-body__title:before {
    /* Label (Bold) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    letter-spacing: 0.02em;
    color: #000000;
    content: "Success";
}

._vue-flash-msg-body__text {
    position: relative;
    left: 46px;
    top: 5px;
}

._vue-flash-msg-body__content:before {
    content: url('/checkmark_circle.png');
    left: 5px;
    top: 45%;
    position: relative;
}

.hide-linehaul {
    display: none;
}

.address-select .vs__dropdown-menu {
    width: 600px !important;
}

.add-stop {
    position: relative;
    bottom: 70px !important;
    left: 20px !important;
}

.save-recurring {
    position: relative;
    top: 250px;
}

.drag {
    cursor: all-scroll;
}
</style>

